export const TEMPLATE_WORKFLOW_INPUT_HANDLE_PREFIX = 'template-input:';
export const TEMPLATE_WORKFLOW_OUTPUT_HANDLE_PREFIX = 'template-output:';

export function buildTemplateWorkflowInputHandleId(slotKey: string): string {
  return `${TEMPLATE_WORKFLOW_INPUT_HANDLE_PREFIX}${slotKey}`;
}

export function buildTemplateWorkflowOutputHandleId(outputIndex: number): string {
  return `${TEMPLATE_WORKFLOW_OUTPUT_HANDLE_PREFIX}${Math.max(0, Math.round(outputIndex))}`;
}

export function parseTemplateWorkflowInputHandleId(handleId?: string | null): string | null {
  if (!handleId?.startsWith(TEMPLATE_WORKFLOW_INPUT_HANDLE_PREFIX)) {
    return null;
  }

  const slotKey = handleId.slice(TEMPLATE_WORKFLOW_INPUT_HANDLE_PREFIX.length).trim();
  return slotKey || null;
}

export function parseTemplateWorkflowOutputIndex(handleId?: string | null): number {
  if (!handleId?.startsWith(TEMPLATE_WORKFLOW_OUTPUT_HANDLE_PREFIX)) {
    return 0;
  }

  const parsed = Number(handleId.slice(TEMPLATE_WORKFLOW_OUTPUT_HANDLE_PREFIX.length));
  if (!Number.isFinite(parsed) || parsed < 0) {
    return 0;
  }

  return Math.round(parsed);
}